var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "-10 10 115 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.069,31.442,59.215,44.154V78.605h0a1.406,1.406,0,0,1-.771,1.253L35.921,91.3a1.406,1.406,0,0,1-2.132-1.2V44.154L12.115,16.2H80.889L69.069,31.442ZM9.935,13.384,2.545,3.851A1.406,1.406,0,0,1,3.586,1.5H89.418v0a1.4,1.4,0,0,1,1.11,2.259l-7.459,9.621Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFilter);
export default __webpack_public_path__ + "static/media/ico-filter.74e43c95efbcb3999b999ab033fc9123.svg";
export { ForwardRef as ReactComponent };